import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import Link from 'components/Link';
import Button from 'components/Button';
import UserSettingsAvatar from './UserSettingsAvatar';
import UserSettingsAvatarsListLoading from './UserSettingsAvatarsListLoading';

import * as actions from 'actions';
import { AvatarShape } from 'entities';
import { getUserProfile, getUserAvatars, getUserAvatarSelection } from 'selectors';

import './style.scss';

class UserSettingsChangeAvatar extends Component {

  constructor() {
    super();

    this.handleAvatarClick = this.handleAvatarClick.bind(this);
    this.handleChangeAvatar = this.handleChangeAvatar.bind(this);
    this.handleFetchMoreAvatars = this.handleFetchMoreAvatars.bind(this);
  }

  componentDidMount() {
    this.props.onFetchAvatars();
    this.props.onChangeSelectedAvatar(this.props.currentUserAvatarId);
  }

  handleAvatarClick(avatarId) {
    this.props.onChangeSelectedAvatar(avatarId);
  }

  handleChangeAvatar(e) {
    e.preventDefault();

    const avatarId = this.props.selectedAvatarId;
    const url = this.props.userAvatars.find(avatar => avatar.id === avatarId).url;

    this.props.onChangeAvatar(avatarId, url);
  }

  handleFetchMoreAvatars(e) {
    e.preventDefault();
    this.props.onFetchAvatars();
  }

  render() {
    return (
      <section className="content-wrapper has-background-medium">
        <div className="wrapper-small is-padded-top">
          <h1>{__('members.avatar.title')}</h1>

          <div className="UserSettingsChangeAvatar">
            {(() => {
              if(this.props.userAvatars.length > 0) {
                return (
                  <div className="avatar-list">
                    {this.props.userAvatars.map(avatar =>
                      <UserSettingsAvatar
                        key={avatar.id}
                        isSelected={avatar.id === this.props.selectedAvatarId}
                        onClick={this.handleAvatarClick}
                        avatar={avatar}
                      />
                    )}
                  </div>
                );
              }
              else if(this.props.isFetching) {
                return (
                  <div className="avatar-list">
                    <UserSettingsAvatarsListLoading />;
                  </div>
                );
              }
            })()}
            <div className="form-buttons">
              <Button
                isYellow
                iconType="preloader-dark"
                hasIcon={this.props.isSubmitting}
                isDisabled={this.props.isFetching || this.props.isSubmitting}
                onClick={this.handleChangeAvatar}
              >
                {__('members.avatar.selectButton')}
              </Button>
              <Button
                isYellow
                iconType="preloader-dark"
                hasIcon={this.props.isFetching}
                isDisabled={this.props.isFetching}
                onClick={this.handleFetchMoreAvatars}
              >
                {__('members.avatar.loadMoreButton')}
              </Button>
              <div className="cancel-link">
                <span className="separator">{__('members.avatar.separator')}</span>
                <Link to="/settings">{__('members.avatar.cancel')}</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

UserSettingsChangeAvatar.propTypes = {
  userAvatars: PropTypes.arrayOf(AvatarShape),
  isFetching: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  selectedAvatarId: PropTypes.number,
  currentUserAvatarId: PropTypes.number,
  onFetchAvatars: PropTypes.func,
  onChangeSelectedAvatar: PropTypes.func,
  onChangeAvatar: PropTypes.func
};

const mapStateToProps = state => {
  const { isFetching, isSubmitting, selectedAvatarId } = getUserAvatarSelection(state);
  const currentUserAvatarId = getUserProfile(state).avatar.id;

  return {
    userAvatars: getUserAvatars(state),
    currentUserAvatarId,
    isFetching,
    isSubmitting,
    selectedAvatarId
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onFetchAvatars: () => {
      dispatch(actions.userAvatarsFetch());
    },
    onChangeSelectedAvatar: avatarId => {
      dispatch(actions.userAvatarsChangeActive(avatarId));
    },
    onChangeAvatar: (avatarId, avatarUrl) => {
      dispatch(actions.userUpdate({ avatar: avatarId }, true, avatarUrl));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserSettingsChangeAvatar);




/** WEBPACK FOOTER **
 ** ./src/members/Main/UserSettings/UserSettingsChangeAvatar/index.js
 **/